var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg142Microphone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "current"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M256,361c57.897,0,105-47.103,105-105c0-11.046-8.954-20-20-20c-11.046,0-20,8.954-20,20c0,35.841-29.159,65-65,65 s-65-29.159-65-65V105c0-35.841,29.159-65,65-65s65,29.159,65,65v51c0,11.046,8.954,20,20,20c11.046,0,20-8.954,20-20v-51 C361,47.103,313.897,0,256,0c-57.897,0-105,47.103-105,105v151C151,313.897,198.103,361,256,361z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M441,256c0-11.046-8.954-20-20-20c-11.046,0-20,8.954-20,20c0,79.953-65.047,145-145,145s-145-65.047-145-145 c0-11.046-8.954-20-20-20s-20,8.954-20,20c0,95.253,72.361,173.923,165,183.926V472h-59c-11.046,0-20,8.954-20,20 c0,11.046,8.954,20,20,20h160c11.046,0,20-8.954,20-20c0-11.046-8.954-20-20-20h-61v-32.074C368.639,429.923,441,351.253,441,256 z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg142Microphone);
export default __webpack_public_path__ + "static/media/142-microphone.402b301846cf03633590364bded6f8ef.svg";
export { ForwardRef as ReactComponent };